import React, { useState } from 'react';
import { Gallery } from 'react-grid-gallery';
import { Lightbox } from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { customImages } from 'sections/gallery/images';
import { IS_MOBILE } from 'constants/responsive';

const slides = customImages.map(({ original, width, height }) => ({
    src: original,
    width,
    height,
}));

export const PicsGallery = () => {
    const [index, setIndex] = useState(-1);

    const handleClick = (index: number) => setIndex(index);
    const imgHeight = IS_MOBILE ? 242 : 308;
    const imgWidth = IS_MOBILE ? '100%' : 444;

    return (
        <div>
            <Gallery
                images={customImages}
                onClick={handleClick}
                enableImageSelection={false}
                margin={10}
                // maxRows={3}
                rowHeight={imgHeight}
                tagStyle={{
                    maxWidth: imgWidth,
                    width: 'auto',
                    height: imgHeight,
                }}
                thumbnailStyle={{
                    maxWidth: imgWidth,
                    width: 'auto',
                    minHeight: imgHeight,
                    objectFit: 'cover',
                }}
                tileViewportStyle={{
                    maxWidth: imgWidth,
                    width: 'auto',
                    height: imgHeight,
                    overflow: 'hidden',
                }}
            />
            <Lightbox
                slides={slides}
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
            />
        </div>
    );
};
